module.exports = __webpack_public_path__ + "static/media/building3.bb40aec5.png";